import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { usePagination } from 'hooks/use-pagination'

// this is refactored into a separate hook so that in places where we do not use the url param updates
// we do not have additional test code bloat with providers/wrappers for routing, etc.
export function usePaginationWithUrlParam(
  data = [],
  itemsPerPage = 10,
  loading = false,
  updateUrl = true
) {
  const history = useHistory()
  const location = useLocation()
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )
  const pageParam = parseInt(params.get('page'), 10) || 1
  const initialPage = pageParam - 1

  const { pagination } = usePagination(data, itemsPerPage, initialPage, loading)

  const changePage = useCallback(
    (selectedItem) => {
      const newPage = pagination.changePage(selectedItem)

      if (updateUrl) {
        history.replace({
          pathname: location.pathname,
          search: `?page=${newPage + 1}`,
          state: location.state
        })
      }
    },
    [history, location, pagination, updateUrl]
  )

  return {
    pagination: {
      ...pagination,
      changePage
    }
  }
}
